import Vue from 'vue';
import VueRouter from 'vue-router';
import Meta from 'vue-meta';
import store from '../store';

Vue.use(VueRouter);
Vue.use(Meta);

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: () => import('@/views/HomePage.vue'),
    meta: { customer: true },
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/Checkout.vue'),
    meta: { requiresAuth: true, customer: true },
  },
  {
    path: '/configurator',
    name: 'configurator',
    component: () => import('@/views/Configurator.vue'),
  },
  {
    path: '/profile',
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/UserProfile.vue'),
    meta: { requiresAuth: true, customer: true },
    children: [
      {
        path: '',
        name: 'profile',
        component: () => import('@/components/profile/UserData.vue'),
        meta: { requiresAuth: true, customer: true },
      },
      {
        path: 'orders',
        component: () => import('@/components/profile/Orders.vue'),
        meta: { requiresAuth: true, customer: true },
      },
      {
        path: 'orders/:order_no',
        name: 'single-order',
        component: () => import('@/components/profile/Order.vue'),
        meta: { requiresAuth: true, customer: true },
      },
      {
        path: 'addresses',
        component: () => import('@/components/profile/Addresses.vue'),
        meta: { requiresAuth: true, customer: true },
      },
      {
        path: 'coupons',
        component: () => import('@/components/profile/Coupons.vue'),
        meta: { requiresAuth: true, customer: true },
      },
    ],
  },
  {
    path: '/order/completed',
    name: 'completed',
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/Completed.vue'),
  },
  {
    path: '/signin',
    name: 'signin',
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/Signin.vue'),
  },
  {
    path: '/verify',
    name: 'verify-email',
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/VerifyYourEmail.vue'),
  },
  {
    path: '/test-me',
    name: 'Test',
    component: () => import('@/views/Test.vue'),
  },
  {
    path: '/brands',
    name: 'Brands',
    component: () => import('@/views/Brands.vue'),
  },
  {
    path: '/brand/:slug',
    name: 'Catalog Brand',
    component: () => import('@/views/CatalogBrand.vue'),
  },
  {
    path: '/product-categories/:slug',
    name: 'Catalog Product Category',
    component: () => import('@/views/CatalogCategory.vue'),
  },
  {
    path: '/404',
    component: () => import('@/views/Error404.vue'),
  },
  {
    path: '*',
    redirect: '/404',
  },
  /* {
    path: '/503',
    component: () => import('@/views/Error503.vue'),
  }, */
  {
    path: '/products/:sku',
    name: 'ProductView',
    component: () => import('@/views/Product.vue'),
  },
  {
    path: '/releases',
    name: 'releases',
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/Releases.vue'),
  },
  {
    path: '/terms-and-conditions',
    name: 'TermsAndConditions',
    component: () => import('@/views/TermsAndConditions.vue'),
  },
  {
    path: '/shipping-and-payments',
    name: 'ShippingAndPayments',
    component: () => import('@/views/ShippingAndPayments.vue'),
  },
  {
    path: '/return-and-refund',
    name: 'ReturnAndRefund',
    component: () => import('@/views/ReturnAndRefund.vue'),
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue'),
  },
  {
    path: '/imprint',
    name: 'Imprint',
    component: () => import('@/views/Imprint.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  Meta,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

const titleLogo = document.createElement('link');
titleLogo.rel = 'icon';
titleLogo.type = 'image/ico';
titleLogo.href = '/salvi-icon.ico';

document.head.appendChild(titleLogo);

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    store.dispatch('auth/auth').then(() => {
      if (!store.getters['auth/authenticated']) {
        next({
          name: 'signin',
          query: { redirect: to.fullPath },
        });
      } else next();
    });
  }

  if (to.fullPath === '/checkout' && !store.getters['cart/products'].length > 0) {
    next('/');
  }

  next();
});

export default router;
